import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Memo, EAA_ErrorText, EAA_Input } from '~/components/EditAndAddItem';
import PickSqCheckBox from '~/components/CheckBox/PickSqCheckBox';

import Sub1 from '../Schedule/Sub1';
import Sub2 from '../Schedule/Sub2';
import Sub3 from '../Schedule/Sub3';

import Sub1Progress1 from './Task/Sub1Progress1';
import Sub1Progress2 from './Task/Sub1Progress2';
import Sub1Progress from './Task/Sub1Progress';
import Sub2ExecutionStatus from './Task/Sub2ExecutionStatus';
import Sub3Deployment from './Task/Sub3Deployment';
import Sub5GridConnection from './Task/Sub5GridConnection';

const styles = (theme) => ({
    root: {
    },
});

const backConductList = [
    { name: '進行補給', value: '進行補給' },
    { name: '進行換員', value: '進行換員' },
    { name: '進行設備維修', value: '進行設備維修' },
    { name: '進行部件裝載', value: '進行部件裝載' },
];

const RegularSchedule = ({ title, ...props }) => {
    const { classes, titleWidth, disabled, returnInputValue, checkChange, changeData, data, z, d, errorBody = {}, errorLeft } = props;
    // const zx = `${z}_`;
    const zx = '';

    useEffect(() => {
    }, []);

    const renderOption = (key, title, text, checkKey) => {
        return (
            <>
                <EAA_Row key={`PPDaily_Area_ShipRegularSchedule_${key}`}>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            {(title)? (<EAA_TitleText width={titleWidth} text={title} bol={true} />): (<EAA_TitleText width={titleWidth} />)}
                            <PickSqCheckBox
                                disabled={disabled}
                                value={data[checkKey] === '1'}
                                onClick={() => changeData({ label: checkKey, data: data[checkKey] === '1' ? '0' : '1' })}
                            />
                            <div style={{ marginLeft: 8, fontWeight: 500, fontSize: 20 }}>{text}</div>
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>
            </>
        );
    };

    const renderOption2Content = () => {
        return (
            <>
                <EAA_Row>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <EAA_TitleText width={titleWidth + 20} />
                            <PickSqCheckBox
                                disabled={disabled}
                                value={data[`${zx}${d}_option2_wait_process_check`] === '1'}
                                onClick={() => changeData({ label: `${zx}${d}_option2_wait_process_check`, data: data[`${zx}${d}_option2_wait_process_check`] === '1' ? '0' : '1' })}
                            />
                            <div style={{ marginLeft: 8, marginRight: 8 }}>等待天氣窗進行 </div>
                            <EAA_Input
                                displayBorder
                                disabled={disabled || data[`${zx}${d}_option2_wait_process_check`] !== '1'}
                                marginRight={0}
                                value={returnInputValue(data[`${zx}${d}_option2_wait_process_action`])}
                                onChange={(data) => changeData({ label: `${zx}${d}_option2_wait_process_action`, data })}
                            />
                            <div style={{ marginLeft: 8, marginRight: 8 }}> 作業</div>
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>
                <EAA_Row>
                    <EAA_Item>
                        <EAA_ItemContainer>
                            <EAA_TitleText width={titleWidth + 20} />
                            <PickSqCheckBox
                                disabled={disabled}
                                value={data[`${zx}${d}_option2_child_check`] === '1'}
                                onClick={() => changeData({ label: `${zx}${d}_option2_child_check`, data: data[`${zx}${d}_option2_child_check`] === '1' ? '0' : '1' })}
                            />
                            <div style={{ marginLeft: 8, marginRight: 8 }}></div>
                            <EAA_Select
                                displayBorder
                                disabled={disabled || data[`${zx}${d}_option2_child_check`] !== '1'}
                                list={backConductList}
                                value={returnInputValue(data[`${zx}${d}_option2_child_action`])}
                                onChange={(data) => changeData({ label: `${zx}${d}_option2_child_action`, data })}
                            />
                        </EAA_ItemContainer>
                    </EAA_Item>
                </EAA_Row>
            </>
        );
    };

    const renderOption5Content = () => {
        return (
            <EAA_Row key={`PPDaily_Area_ShipRegularSchedule_${zx}${d}_note`}>
                <EAA_Item>
                    <EAA_ItemContainer>
                        <EAA_TitleText width={titleWidth} />
                        <EAA_Memo
                            displayBorder
                            disabled={disabled}
                            hint='業者自填詳答'
                            value={returnInputValue(data[`${zx}${d}_option5_note`])}
                            onChange={(data) => changeData({ label: `${zx}${d}_option5_note`, data })}
                        />
                    </EAA_ItemContainer>
                    {errorBody[`${zx}${d}_option5_note`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
                </EAA_Item>
            </EAA_Row>
        )
    };

    const renderOptionZ405Content = () => {
        return (
            <EAA_Row key={`PPDaily_Area_ShipRegularSchedule_${zx}${d}_other_description`}>
                <EAA_Item>
                    <EAA_ItemContainer>
                        <EAA_TitleText width={titleWidth} />
                        <EAA_Memo
                            displayBorder
                            disabled={disabled}
                            hint='自填文字'
                            value={returnInputValue(data[`${zx}${d}_other_opt_description`])}
                            onChange={(data) => changeData({ label: `${zx}${d}_other_opt_description`, data })}
                        />
                    </EAA_ItemContainer>
                    {errorBody[`${zx}${d}_other_opt_description`] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
                </EAA_Item>
            </EAA_Row>
        );
    };

    // opt2 (ok)
    // recently_option2_wait_process_check: "1", // 等待天氣窗進行 __(自填)作業, (checkbox)
    // recently_option2_wait_process_action: "", // 等待天氣窗進行 __(自填)作業, (做什麼動作)

    // opt2 - sub1 (不需要, 因為把他們放進 sub1_progress array 中, 每一個 job object 都有一個 ischeck)
    // recently_option2_wait_window_load_check: "1", // 等待天氣窗裝載, (checkbox)
    // recently_option2_wait_assemble_check: "1", // 等待天氣窗預組裝, (checkbox)
    
    // opt2 (ok)
    // recently_option2_child_check: "0", // 執行動作, (checkbox)
    // recently_option2_child_action: "0", // 改成進行補給, 進行換員, 進行設備維修, 進行部件裝載 (做什麼動作)
    
    // opt6, opt7 (ok)
    // recently_optionX_wait_window_check: "1", // 於風場等待天氣窗, (checkbox)
    // recently_optionX_go_wind_field_check: "1", // 前往風場, (checkbox)

    return (
        <>
            {
                (z === 'z1' || z === 'z2' || z === 'z3') &&
                <>
                    {renderOption('option1', title, '返回＿港', `${zx}${d}_option1_check`)}
                    
                    {renderOption('option2', null, '於＿港裝載', `${zx}${d}_option2_check`)}
                    {data[`${zx}${d}_option2_check`] === '1' && <Sub1Progress {...props} baseType="等待裝載" />}
                    {data[`${zx}${d}_option2_check`] === '1' && <Sub1Progress {...props} baseType="等待預組裝" />}
                    {data[`${zx}${d}_option2_check`] === '1' && renderOption2Content()}
                    {/* {data[`${zx}${d}_option2_check`] === '1' && <Sub2ExecutionStatus {...props} />} */}

                    {renderOption('option3', null, '安裝', `${zx}${d}_option3_check`)}
                    {data[`${zx}${d}_option3_check`] === '1' && <Sub3Deployment {...props} />}
                    
                    {renderOption('option6', null, '於風場等待天氣窗', `${zx}${d}_optionX_wait_window_check`)}
                    {renderOption('option7', null, '前往風場', `${zx}${d}_optionX_go_wind_field_check`)}

                    {renderOption('option4', null, '無規劃', `${zx}${d}_option4_check`)}
                    {renderOption('option5', null, '已完成', `${zx}${d}_option5_check`)}
                    {data[`${zx}${d}_option5_check`] === '1' && renderOption5Content()}
                </>
            }
            {
                (z === 'z4' ) &&
                <>
                    {/* key, title, text, checkKey */}
                    {renderOption('optionZ401', title, '無提出申請', `${zx}${d}_no_appl_made_check`)}

                    {renderOption('optionZ402', null, '提出申請', `${zx}${d}_with_appl_made_check`)}
                    {data[`${zx}${d}_with_appl_made_check`] === '1' && <Sub5GridConnection {...props} gridConnectionActionType="提出申請" />}

                    {renderOption('optionZ403', null, '併聯完成', `${zx}${d}_with_grid_connection_done_check`)}
                    {data[`${zx}${d}_with_grid_connection_done_check`] === '1' && <Sub5GridConnection {...props} gridConnectionActionType="併聯完成" />}

                    {renderOption('optionZ404', null, '持續進行接電測試', `${zx}${d}_with_power_connection_check`)}
                    {renderOption('optionZ405', null, '其他', `${zx}${d}_other_opt_check`)}
                    {data[`${zx}${d}_other_opt_check`] === '1' && renderOptionZ405Content()}
                </>
            }

        </>
    );    
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(RegularSchedule);
